import { component$, Slot } from "@builder.io/qwik";
import { Link } from "@builder.io/qwik-city";
import { type FormStore } from "@modular-forms/qwik";
import { LuExternalLink } from "@qwikest/icons/lucide";
import { Button } from "~/components/ui/button";
import { hasError } from "~/lib/form";

export interface ProfileEditHeaderProps {
  title: string;
  description?: string;
  form?: FormStore<any, any>;
  username: string;
}

export const ProfileEditHeader = component$<ProfileEditHeaderProps>(
  ({ title, description, form, username }) => {
    return (
      <div class="sticky top-0 z-40 flex h-16 items-center justify-end gap-4 bg-white/50 backdrop-blur-lg">
        <div class="grow">
          <h1 class="font-heading text-primary text-2xl">{title}</h1>
          {description && <p class="text-secondary text-sm">{description}</p>}
        </div>
        {form && hasError(form) && (
          <div class="text-xs text-red-700">
            Please fix the errors below before saving.
          </div>
        )}
        <Link href={`/${username}`} target="_blank">
          <Button
            variant="outline"
            type="button"
            class="flex shrink-0 items-center gap-2"
          >
            View Profile <LuExternalLink />
          </Button>
        </Link>
        {form && (
          <Button
            disabled={!form.touched || form.submitting || hasError(form)}
            type="submit"
            class="shrink-0"
          >
            {form.submitting ? "Saving..." : "Save"}
          </Button>
        )}
        <Slot />
      </div>
    );
  },
);
